export default __webpack_public_path__ + "af81d41d71f7b302ba661ec5b53e1627.svg";